import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FileService } from '@front-end/core/services';
import { BehaviorSubject } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'ui-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileInputComponent implements OnChanges {
  @ViewChild('placeholder', { read: ElementRef }) placeholder!: ElementRef;
  @ViewChild('uploader', { static: true }) uploader!: ElementRef;

  @Input() label?: string;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() value: {
    url: string;
    name: string;
  } | null = null;

  @Output() openPreviewEvent = new EventEmitter();
  @Output() attachment = new EventEmitter<{
    url: string;
    name: string;
  } | null>();

  constructor(
    private changeRef: ChangeDetectorRef,
    private fileService: FileService
  ) {}

  attachment$ = new BehaviorSubject<{ url: string; name: string } | null>(null);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.attachment$.next(changes['value'].currentValue ?? null);
    }
  }

  addAttachment(attachment: { url: string; name: string }): void {
    this.attachment.emit(attachment);
    this.attachment$.next(attachment);
  }

  onChangeAttachment(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const fileName = file.name;
      this.fileService
        .read(file)
        .pipe(
          tap((fileUrl) => {
            const attachment = { url: fileUrl, name: fileName };
            this.addAttachment(attachment);
            this.changeRef.markForCheck();
            this.uploader.nativeElement.value = null;
          }),
          untilDestroyed(this)
        )
        .subscribe();
    }
  }

  removeAttachment(): void {
    this.attachment.emit(null);
    this.attachment$.next(null);
  }

  openSlider(attachment: string) {
    this.openPreviewEvent.emit(attachment);
  }
}
